export const SOCKET_URL = 'https://ws.synfutures.com/public';
